import { useEffect, useState } from "react";
import useUserInvoiceDefaults from '@/services/admin-services/query/useUserInvoiceDefaults.js'; // Ajout de l'import

export const useFormEditBills = (editData, nameInUserFormated) => {

    const toNumber = (value) => Number(value) || 0;

    const [consultantUuid, setConsultantUuid] = useState(nameInUserFormated || "");
    const [customer, setCustomer] = useState(editData?.clientName || "");
    const [billNumber, setBillNumber] = useState(editData?.invoiceNumber || "");
    const [days, setDays] = useState(editData?.daysWorked || 0);
    const [amountClient, setAmountClient] = useState(editData?.amountClient || 0);
    const [amountConsultant, setAmountConsultant] = useState(editData?.amountConsultant || 0);
    const [currency, setCurrency] = useState(editData?.currency || "EUR");
    const [tJMClient, setTJMClient] = useState(editData?.dailyRateClient || 0);
    const [tJMConsultant, setTJMConsultant] = useState(editData?.dailyRateConsultant || 0);
    const [periodStart, setPeriodStart] = useState(editData?.periodStart || "");
    const [periodEnd, setPeriodEnd] = useState(editData?.periodEnd || "");
    const [invoiceDate, setInvoiceDate] = useState(editData?.invoiceDate || "");
    const [commission, setCommission] = useState(editData?.commission || 0);
    const [manualCommission, setManualCommission] = useState(editData?.manualCommission || false);
    const [paymentDate, setPaymentDate] = useState(editData?.paymentDate || "");

    const [consultantUuidError, setConsultantUuidError] = useState(null);
    const [customerError, setCustomerError] = useState(null);
    const [billNumberError, setBillNumberError] = useState(null);
    const [daysError, setDaysError] = useState(null);
    const [amountClientError, setAmountClientError] = useState(null);
    const [amountConsultantError, setAmountConsultantError] = useState(null);
    const [currencyError, setCurrencyError] = useState(null);
    const [tJMClientError, setTJMClientError] = useState(null);
    const [tJMConsultantError, setTJMConsultantError] = useState(null);
    const [periodStartError, setPeriodStartError] = useState(null);
    const [periodEndError, setPeriodEndError] = useState(null);
    const [invoiceDateError, setInvoiceDateError] = useState(null);
    const [commissionError, setCommissionError] = useState(null);
    const [paymentDateError, setPaymentDateError] = useState(null);

    const [formIsValid, setFormIsValid] = useState(true);

    // Ajout de l'appel à useUser
    const { user } = useUserInvoiceDefaults(consultantUuid);

    const [defaultValues, setDefaultValues] = useState({
        monthlyCommissionEur : user?.consultantInvoiceDefaults?.monthlyCommissionEur || 0,
        dailyCommissionEur : user?.consultantInvoiceDefaults?.dailyCommissionEur || 0,
        manualCommission: user?.consultantInvoiceDefaults?.manualCommission || false,
        dailyRateConsultantEur: user?.consultantInvoiceDefaults?.dailyRateConsultantEur || 0,
        defaultCommissionPerWorkingDay: user?.consultantProfile?.defaultCommissionPerWorkingDay || 0,
        defaultCommissionPerMonthInDailyRate: user?.consultantProfile?.defaultCommissionPerMonthInDailyRate || 0
    });

    const calculateDefaultCommission = (
        daysWorked = days,
        dailyRateConsultant = tJMConsultant,
        defaults = defaultValues,
        isManualCommission = manualCommission
    ) => {
        const safeDaysWorked = toNumber(daysWorked);
        const safeDailyRateConsultant = toNumber(dailyRateConsultant);

        if (isManualCommission === false) {
            return (safeDaysWorked * toNumber(defaults?.defaultCommissionPerWorkingDay))
                + (safeDailyRateConsultant * toNumber(defaults?.defaultCommissionPerMonthInDailyRate));
        }

        return (safeDaysWorked * toNumber(defaults?.dailyCommissionEur)) + toNumber(defaults?.monthlyCommissionEur);
    };

    useEffect(() => {
        setAmountClient(tJMClient * days)
    }, [tJMClient, days]);

    useEffect(() => {
        setAmountConsultant(tJMConsultant * days)
    }, [tJMConsultant, days]);

    // Validation targeting specific fields
    useEffect(() => {
        (consultantUuid || consultantUuidError != null) && validateForm("consultantUuidErrorTest");
    }, [consultantUuid]);

    useEffect(() => {
        (customer || customerError != null) && validateForm("customerErrorTest");
    }, [customer]);

    useEffect(() => {
        (billNumber || billNumberError != null) && validateForm("billNumberErrorTest");
    }, [billNumber]);

    useEffect(() => {
        (days || daysError != null) && validateForm("daysErrorTest");
    }, [days]);


    useEffect(() => {
        (currency || currencyError != null) && validateForm("currencyErrorTest");
    }, [currency]);

    useEffect(() => {
        // console.log("use effect tjmclient", tJMClient || tJMClientError, tJMClient, tJMClientError);
        (tJMClient || tJMClientError != null) && validateForm("tJMClientErrorTest");
    }, [tJMClient]);

    useEffect(() => {
        (tJMConsultant || tJMConsultantError != null) && validateForm("tJMConsultantErrorTest");
    }, [tJMConsultant]);

    useEffect(() => {
        (periodStart || periodStartError != null) && validateForm("periodStartErrorTest");
    }, [periodStart]);

    useEffect(() => {
        (periodEnd || periodEndError != null) && validateForm("periodEndErrorTest");
    }, [periodEnd]);

    useEffect(() => {
        (invoiceDate || invoiceDateError != null) && validateForm("invoiceDateErrorTest");
    }, [invoiceDate]);

    useEffect(() => {
        (commission || commissionError != null) && validateForm("commissionErrorTest");
    }, [commission]);

    useEffect(() => {
        (paymentDate || paymentDateError != null) && validateForm("paymentDateErrorTest");
    }, [paymentDate]);

    useEffect(() => {
        if (manualCommission === false) {
            setCommission(calculateDefaultCommission(days, tJMConsultant));
        }
    }, [manualCommission, days, tJMConsultant, defaultValues]);

    useEffect(() => {
        // Si editData n'a pas la valeur, on la prend du user si dispo
        if (editData?.manualCommission == null && user?.consultantInvoiceDefaults?.manualCommission !== undefined) {
            setManualCommission(user.consultantInvoiceDefaults.manualCommission);
        }
        if (!editData?.dailyRateConsultant && user?.consultantInvoiceDefaults?.dailyRateConsultantEur !== undefined) {
            setTJMConsultant(user.consultantInvoiceDefaults.dailyRateConsultantEur);
        }
        const nextDefaultValues = {
            monthlyCommissionEur: user?.consultantInvoiceDefaults?.monthlyCommissionEur || 0,
            dailyCommissionEur: user?.consultantInvoiceDefaults?.dailyCommissionEur || 0,
            manualCommission: user?.consultantInvoiceDefaults?.manualCommission || false,
            dailyRateConsultantEur: user?.consultantInvoiceDefaults?.dailyRateConsultantEur || 0,
            defaultCommissionPerWorkingDay: user?.consultantProfile?.defaultCommissionPerWorkingDay || 0,
            defaultCommissionPerMonthInDailyRate: user?.consultantProfile?.defaultCommissionPerMonthInDailyRate || 0
        };

        setDefaultValues(nextDefaultValues);

        if (!editData?.commission) {
            const rateForDefault = editData?.dailyRateConsultant ?? user?.consultantInvoiceDefaults?.dailyRateConsultantEur ?? tJMConsultant;
            setCommission(calculateDefaultCommission(days, rateForDefault, nextDefaultValues));
        }

        // console.log("useFormEditBills user", user);
    }, [user, editData, days]);

    const useDefaultValues = (type) => {
        // console.log("default values used for", type, defaultValues);
        switch (type) {
            case "commission":
                setCommission(calculateDefaultCommission(days, tJMConsultant));
                break;
            case "dailyRateConsultant":
                setTJMConsultant(defaultValues?.dailyRateConsultantEur || 0);
                break;
            default:
                break;
        }
    }
    // Reset form to default values
    const resetForm = () => {
        setConsultantUuid("");
        setCustomer("");
        setBillNumber("");
        setDays(0);
        setAmountClient(0);
        setAmountConsultant(0);
        setCurrency("EUR");
        setTJMClient(0);
        setTJMConsultant(0);
        setPeriodStart("");
        setPeriodEnd("");
        setInvoiceDate("");
        setPaymentDate("");
        setConsultantUuidError(null);
        setCustomerError(null);
        setBillNumberError(null);
        setDaysError(null);
        setAmountClientError(null);
        setAmountConsultantError(null);
        setCurrencyError(null);
        setTJMClientError(null);
        setTJMConsultantError(null);
        setPeriodStartError(null);
        setPeriodEndError(null);
        setInvoiceDateError(null);
        setPaymentDateError(null);
        setCommission(0);
        setManualCommission(true);
    };

    // Validation logic
    function validateForm(varToTest) {
        switch (varToTest) {
            case "all":
                setConsultantUuidError(!consultantUuid);
                setCustomerError(!customer);
                setBillNumberError(!billNumber);
                setDaysError(!days);

                setCurrencyError(!currency);
                setTJMClientError(!tJMClient);
                setTJMConsultantError(!tJMConsultant);
                setPeriodStartError(!periodStart);
                setPeriodEndError(!periodEnd);
                setInvoiceDateError(!invoiceDate);
                setPaymentDateError(false); // rendre optionnel
                setCommissionError(commission < 0);

                break;

            case "consultantUuidErrorTest":
                setConsultantUuidError(!consultantUuid);
                break;
            case "customerErrorTest":
                setCustomerError(!customer);
                break;
            case "billNumberErrorTest":
                setBillNumberError(!billNumber);
                break;
            case "daysErrorTest":
                setDaysError(!days || days <= 0);
                break;
            case "currencyErrorTest":
                setCurrencyError(!currency);
                break;
            case "tJMClientErrorTest":
                setTJMClientError(!tJMClient || tJMClient <= 0);
                break;
            case "tJMConsultantErrorTest":
                setTJMConsultantError(!tJMConsultant || tJMConsultant <= 0);
                break;
            case "periodStartErrorTest":
                setPeriodStartError(!periodStart);
                break;
            case "periodEndErrorTest":
                setPeriodEndError(!periodEnd);
                break;
            case "invoiceDateErrorTest":
                setInvoiceDateError(!invoiceDate);
                break;
            case "commissionErrorTest":
                setCommissionError(commission < 0);
                break;
            case "paymentDateErrorTest":
                setPaymentDateError(false); // rendre optionnel
                break;

            default:
                console.error("Unknown validation test:", varToTest);
                break;
        }

        // Overall form validation
        if (!consultantUuid || !customer || !billNumber || !days || !amountClient || !amountConsultant || !currency || !tJMClient || !tJMConsultant || !periodStart || !periodEnd || !invoiceDate /* retirer !paymentDate */) {
            return false;
        }
        return true;
    }
    return {
        consultantUuid,
        customer,
        billNumber,
        days,
        amountClient,
        amountConsultant,
        currency,
        tJMClient,
        tJMConsultant,
        periodStart,
        periodEnd,
        invoiceDate,
        commission,
        manualCommission,
        paymentDate,
        defaultValues,
        consultantUuidError,
        customerError,
        billNumberError,
        daysError,
        amountClientError,
        amountConsultantError,
        currencyError,
        tJMClientError,
        tJMConsultantError,
        periodStartError,
        periodEndError,
        invoiceDateError,
        commissionError,
        paymentDateError,
        formIsValid,
        setConsultantUuid,
        setCustomer,
        setBillNumber,
        setDays,
        setAmountClient,
        setAmountConsultant,
        setCurrency,
        setTJMClient,
        setTJMConsultant,
        setPeriodStart,
        setPeriodEnd,
        setInvoiceDate,
        setPaymentDate,
        setCommission,
        setManualCommission,
        calculateDefaultCommission,
        validateForm,
        resetForm,
        useDefaultValues
    };
};
